<template>
  <div class="timestamp-cell-renderer">
    <span>{{ formatDate(timestamp, params.format) }}</span>
  </div>
</template>

<script setup>
import { computed, toRefs } from 'vue'

import { formatDate } from '@shared/utils/date'

const props = defineProps({
  params: {
    type: Object,
    default: () => ({}),
  },
})
const { params } = toRefs(props)

const timestamp = computed(() => {
  return params.value.date || params.value.data.timestamp
})
</script>
